// ============================================
// clearVoiceSessionTimers — cancel all background timers
// ============================================
// Wave 5b — extracted from endSession() Phase 1.
//
// Three timers can be active during a live voice session:
//   - greetingRetryTimeoutRef  (setTimeout) — retries the initial greeting if
//     Azure Realtime stalls before first response.
//   - responseStallTimerRef    (setTimeout) — watchdog that nudges the model
//     when a response.created arrives but no audio follows.
//   - idleTimeoutRef           (setInterval) — periodic activity check that
//     ends the session after silence.
//
// All three must be cancelled at session-end. They are nulled so any
// late-firing closure check (`if (ref.current) …`) becomes a no-op.

import type { MutableRefObject } from 'react'

export interface ClearVoiceSessionTimersRefs {
  greetingRetryTimeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | null>
  responseStallTimerRef: MutableRefObject<ReturnType<typeof setTimeout> | null>
  idleTimeoutRef: MutableRefObject<ReturnType<typeof setInterval> | null>
}

export const clearVoiceSessionTimers = (
  refs: ClearVoiceSessionTimersRefs,
): void => {
  const { greetingRetryTimeoutRef, responseStallTimerRef, idleTimeoutRef } = refs

  if (greetingRetryTimeoutRef.current) {
    clearTimeout(greetingRetryTimeoutRef.current)
    greetingRetryTimeoutRef.current = null
  }
  if (responseStallTimerRef.current) {
    clearTimeout(responseStallTimerRef.current)
    responseStallTimerRef.current = null
  }
  if (idleTimeoutRef.current) {
    clearInterval(idleTimeoutRef.current)
    idleTimeoutRef.current = null
  }
}
